import cx from 'classnames';
import styles from '../TestDriveCenter.module.css';

export default function TestDriveCenterStatement() {
  return (
    <section
      className="relative flex min-h-[84vh] items-center overflow-hidden bg-[var(--cvna-navy)] scroll-mt-64 max-[920px]:min-h-[auto]"
      id="statement"
    >
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute bottom-[-1080px] left-1/2 h-[1900px] w-[1900px] -translate-x-1/2 rounded-full border-[1.5px] border-[rgba(255,255,255,0.09)]" />
        <div className="absolute bottom-[-1320px] left-1/2 h-[2560px] w-[2560px] -translate-x-1/2 rounded-full border-[1.5px] border-[rgba(255,255,255,0.06)]" />
        <div className="absolute bottom-[-1620px] left-1/2 h-[3260px] w-[3260px] -translate-x-1/2 rounded-full border-[1.5px] border-[rgba(255,255,255,0.035)]" />
      </div>
      <div className="relative mx-auto max-w-[1180px] px-[clamp(20px,4vw,56px)] pb-[clamp(120px,20vh,240px)] pt-[clamp(72px,11vh,140px)] text-center max-[920px]:pb-[clamp(48px,7vh,80px)] max-[920px]:pt-[clamp(64px,9vh,96px)]">
        <div
          className={cx(styles.eyebrow, styles.statementEyebrow, styles.animIn)}
        >
          A new kind of dealership
        </div>
        <h2
          className={cx(
            styles.animIn,
            'mx-auto max-w-[18ch] font-[family-name:var(--font-display)] text-[clamp(38px,6.2vw,96px)] font-black uppercase leading-[0.94] tracking-[-0.02em] text-white'
          )}
        >
          We turned the dealership into a playground.
        </h2>
        <p
          className={cx(
            styles.animIn,
            'mx-auto mt-[34px] max-w-[560px] text-[clamp(17px,1.5vw,21px)] font-normal leading-[1.6] text-[rgba(255,255,255,0.74)]'
          )}
        >
          No salespeople. No commissions. No one riding along. Just a lot full
          of brand-new cars and the keys in your hand.
        </p>
      </div>
    </section>
  );
}
